import { generatePath, matchPath } from 'react-router-dom';

import { RouteEnum } from '@/models/route/Route.model.ts';
import { MY_PROFILE_ROUTES } from '@/views/myProfile/constants/myProfile.constants.ts';

const ASSISTANT_SEARCH = '?scrollTo=assistant';

const isDevelopmentSubpath = (subpath: string | undefined): boolean =>
  subpath === 'development' || subpath?.startsWith('development/') === true;

export const getGlobalAiAssistantPath = (pathname: string): string => {
  const employeeProfileMatch = matchPath(RouteEnum.EMPLOYEE_PROFILE_NEW, pathname);
  const employeeProfileId = employeeProfileMatch?.params.id;

  if (!employeeProfileId) return `${MY_PROFILE_ROUTES.development}${ASSISTANT_SEARCH}`;

  return `${generatePath(RouteEnum.EMPLOYEE_PROFILE_NEW, {
    '*': 'development/plan',
    id: employeeProfileId,
  })}${ASSISTANT_SEARCH}`;
};

export const isProfileDevelopmentPath = (pathname: string): boolean => {
  const myProfileSubpath = matchPath(RouteEnum.MY_PROFILE, pathname)?.params['*'];
  const employeeProfileSubpath = matchPath(RouteEnum.EMPLOYEE_PROFILE_NEW, pathname)?.params['*'];

  return isDevelopmentSubpath(myProfileSubpath) || isDevelopmentSubpath(employeeProfileSubpath);
};
